/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { useLocalization } from '@/data/Localization';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { CatalogEntryListPagination } from './Pagination';
import { CatalogEntryListSort } from './Sort';
import { resultsHeaderSx, articleCountSx } from '../styles/container';

export const CatalogEntryListResultsHeader: FC<{total:number}> = ({total}) => {
	const productGridNLS = useLocalization('ProductGrid').Labels;
	return (
		<Stack sx={resultsHeaderSx} >
			<Typography sx={articleCountSx} >
				{productGridNLS.ProductsCount.t({count: total || 0 })}
			</Typography>
			<CatalogEntryListPagination />
			{total && total > 0 ? <CatalogEntryListSort /> : null}
		</Stack>
	);
};
 